export default function () {
  return {
    mainBanner: null,
    mainBRK: null,
    mainToday: null,
  };
}
